import { render, staticRenderFns } from "./SuratAdmin.vue?vue&type=template&id=532ee981&scoped=true"
import script from "./SuratAdmin.vue?vue&type=script&lang=js"
export * from "./SuratAdmin.vue?vue&type=script&lang=js"
import style0 from "./SuratAdmin.vue?vue&type=style&index=0&id=532ee981&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ee981",
  null
  
)

export default component.exports